// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7b32c56f","455":"493b5d7e"}[chunkId] + ".chunk.js";
};